import { ReactNode } from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

const Text = styled.p`
  margin-top: 40px;

  ${typeStyle('-ds-font-title-3-regular')}

  ${media.md`
    margin-top: 60px;
  `}
`

const Outer = styled.div<{ backgroundColor?: string }>`
  padding: 16px;
  border-radius: 16px;

  text-align: left;

  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  ${({ backgroundColor }) =>
    backgroundColor &&
    `
    background-color: ${backgroundColor};
  `};

  flex-shrink: 0;
  flex-grow: 0;
  width: 236px;

  svg {
    width: 45px;
    height: 45px;
  }

  ${media.md`
    width: 300px;
    min-height: 273px;

    svg {
      width: 64px;
      height: 64px;
    }
  `}
`

type ValueCardProps = {
  icon: ReactNode
  text: ReactNode
  backgroundColor?: string
}

const ValueCard = ({ icon, text, backgroundColor }: ValueCardProps) => {
  return (
    <Outer backgroundColor={backgroundColor}>
      {icon || <svg />}
      <Text>{text}</Text>
    </Outer>
  )
}

export default ValueCard
